import React, { useState, useEffect } from 'react'
import { FaBars } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavLinks, NavItem } from './NavbarElements'
import { animateScroll as scroll } from 'react-scroll'
import logo from '../../images/joyforge nav.png' 

const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false)

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true)
    } else {
      setScrollNav(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeNav)
    return () => {
      window.removeEventListener('scroll', changeNav)
    }
  }, [])

  const toggleHome = () => {
    scroll.scrollToTop()
  }

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to='/' onClick={toggleHome}>
              <img src={logo} alt="Joyforge Technologies Logo" style={{ height: 'auto', width: '150px', maxWidth: '100%' }} />
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks to='about' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  About
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='vision' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Vision
                </NavLinks>
              </NavItem>
              
              {/*<NavItem>
                <NavLinks to='services' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Courses
                </NavLinks>
              </NavItem>
              */}
              <NavItem>
                <NavLinks to='Mission' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Mission
                </NavLinks>
              </NavItem>
            
              <NavItem>
                <NavLinks to='partner' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
                  Join Us
                </NavLinks>
              </NavItem>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  )
}

export default Navbar
